// Fixed pills + duration columns for list-row metadata alignment.
// @ts-check
import { Box } from '@mui/material';
import TaskRowPillsCol from '@/features/tasks/components/atoms/TaskRowPillsCol';
import TaskDurationBadge from '@/features/tasks/components/atoms/TaskDurationBadge';
import { buildTaskRowDurationColSx } from '@/components/ui/buildTaskRowTitleTrailingSx';

/** @param {object} props */
export function resolveTaskMetadataProps(props) {
  return {
    ...props,
    isMasterView: props.isMasterView ?? false,
    isExecutionView: props.isExecutionView ?? false,
    isPlanView: props.isPlanView ?? false,
    isDashboardView: props.isDashboardView ?? false,
    isDashboardSurface: props.isDashboardSurface ?? false,
    isTodayUpcomingSurface: props.isTodayUpcomingSurface ?? false,
    isSubtaskView: props.isSubtaskView ?? false,
    isCompleted: props.isCompleted ?? false,
    listId: props.listId ?? null,
    task: props.task ?? null,
    tasksMap: props.tasksMap ?? null,
  };
}

/**
 * @param {{
 *   show: boolean,
 *   visibleProjects: string[],
 *   projectDisplayMap: Map<string, string>,
 *   projectColorMap?: Map<string, number>,
 *   allContexts: string[],
 *   contextDisplayMap: Map<string, string>,
 *   denseChips: boolean,
 *   isExecutionView: boolean,
 *   showDuration: boolean,
 *   isFocused: boolean,
 *   focusStartTime: number|null,
 *   displayDuration: number,
 *   estimatedDuration: number|undefined,
 *   isRollup: boolean,
 *   showDurationIcon: boolean,
 * }} props
 */
export function renderFixedTrailingColumns({
  show,
  visibleProjects,
  projectDisplayMap,
  projectColorMap,
  allContexts,
  contextDisplayMap,
  denseChips,
  isExecutionView,
  showDuration,
  isFocused,
  focusStartTime,
  displayDuration,
  estimatedDuration,
  isRollup,
  showDurationIcon,
}) {
  if (!show) return null;

  const hasProjectPills = (visibleProjects?.length ?? 0) > 0;
  const hasContextPills =
    !isExecutionView && (allContexts?.length ?? 0) > 0;
  const showPillsCol = hasProjectPills || hasContextPills;

  return (
    <>
      {showPillsCol ? (
        <TaskRowPillsCol
          visibleProjects={visibleProjects}
          projectDisplayMap={projectDisplayMap}
          projectColorMap={projectColorMap}
          allContexts={allContexts}
          contextDisplayMap={contextDisplayMap}
          denseChips={denseChips}
          isExecutionView={isExecutionView}
        />
      ) : null}
      <Box
        className="task-item__duration-col"
        data-testid="task-item__duration-col"
        sx={buildTaskRowDurationColSx()}
      >
        {showDuration ? (
          <TaskDurationBadge
            isFocused={isFocused}
            focusStartTime={focusStartTime}
            displayDuration={displayDuration}
            estimatedDuration={estimatedDuration}
            isRollup={isRollup}
            className="task-item__duration"
            showIcon={showDurationIcon}
          />
        ) : null}
      </Box>
    </>
  );
}
